import {
  makeExportAcademicManagementGroups,
  makeExportAcademicManagementInternshipLocations,
  makeExportAcademicManagementProfessionals,
  makeExportAcademicManagementTasks,
  makeGetAcademicManagementGroups,
  makeGetAcademicManagementInternshipLocations,
  makeGetAcademicManagementProfessionals,
  makeGetAcademicManagementTasks,
} from 'main/factories/usecases/reports/remote-academic-management-follow-up-factory';
import { AcademicOverview } from 'presentation/app/modules/Reports/pages/academic-overview';
import React from 'react';

export const MakeAcademicOverview: React.FC = () => {
  return (
    <AcademicOverview
      getGroups={makeGetAcademicManagementGroups()}
      getTasks={makeGetAcademicManagementTasks()}
      getInternshipLocations={makeGetAcademicManagementInternshipLocations()}
      getProfessionals={makeGetAcademicManagementProfessionals()}
      exportGroups={makeExportAcademicManagementGroups()}
      exportTasks={makeExportAcademicManagementTasks()}
      exportInternshipLocations={makeExportAcademicManagementInternshipLocations()}
      exportProfessionals={makeExportAcademicManagementProfessionals()}
    />
  );
};
